<template>
  <div v-loading="loading">
    <find-client :visible="visibleModalFindClient" :data="{}"/>

    <div class="scheduler"
         @mousemove="moveScheduler"
         @mousedown="mousedown"
         @mouseup="mouseup"
         @mouseleave="mouseleave"
         ref="schedulerView"
         @scroll.stop="scrollScheduler"
        :style="{ 'cursor' : dragAndMoveScheduler.isDown ? 'all-scroll' : 'default'}">

      <div
          class="scheduler__column column"
          ref="timelineRow"
          :style="timeLineStyle">

        <div class=" column__cell header time-icon" style="margin-bottom: 37px;"><i class="el-icon-time"></i></div>

        <div class="current-time" ref="currentTime" :style="styleCurrentTime" v-if="isToday">
          <div
              class="current-time__time"
          > {{ timeFormatter(currentTime) }}
          </div>
        </div>

        <div
            v-for="h in sumGap()"
            :key="h"
            :style="{ height: setting.unitDivW + 'px' }"
            class="sc-time"
        >
          <div>{{ h.substr(-2) === '00' || h.substr(-2) === '30' ? h : '' }}</div>
        </div>
      </div>

      <div class="scheduler__column scheduler__column_hidden column">

        <div
            v-for="h in sumGap()"
            :key="h"
            :style="{ height: setting.unitDivW + 'px' }"
            class="sc-time"
        >

          <div class="sc-time__line" :style="{'width' : width - 108 + 'px' }" v-if="h.substr(-2) === '00' || h.substr(-2) === '30'"></div>
        </div>
      </div>

      <div
          v-for="(row, index) in scheduleData"
          :key="index"
          class="scheduler__column column"
          :style="{ 'min-width': setting.rowH + 'px' }"
          @dragenter="setDragenterRow(index)"
      >
        <div class="column__cell header">{{ row.title }}</div>

        <unit-div
            v-for="n in sumGap(row.duration).length"
            :key="'unit' + n"
            :row-index="index"
            :key-index="n"
            :row-data="row"
            :is-business="isBusiness(index, n - 1)"
            :is-selecting="isSelecting"
            :is-selecting-row-index="isSelectingRowIndex"
            :height="setting.unitDivW * (row.duration / setting.unit) + 'px'"
            @click="clickStartTime"
            @mouse-enter="adjustTimeRange"
            @mouse-up="selectEndTime"
            @set-dragenter-row-and-index="setDragenterRowAndIndex"
            :class="['column__cell', isHourTime(index, n) ? 'hour-line' : '']"
        />

        <reserved-div
            v-for="(detail, keyNo) in row.taken_appointment"
            :nowDate="currentTime"
            :key="'res' + keyNo"
            :id="detail.id"
            :moving="detail.moving"
            :disable="detail.disable"
            :row-index="index"
            :key-no="keyNo"
            :date-start="detail.start"
            :date-end="detail.end"
            :user="detail.user"
            :unit-height="setting.unitDivW"
            :unit-width="setting.rowH"
            :title-div-height="setting.titleDivW"
            :border-height="setting.borderW"
            :min-date="dates.start"
            :max-date="dates.end"
            :unit="setting.unit"
            :clear-switch="clearSwitch"
            :dragenter-row-index="dragenterRowIndex"
            :dragenter-key-index="dragenterKeyIndex"
            :is-selecting="isSelecting"
            :is-selecting-row-index="isSelectingRowIndex"
            :is-selecting-index="isSelectingIndex"
            @set-dragenter-row-and-index="setDragenterRowAndIndex"
            @move-schedule-data="moveScheduleData"
            @edit-schedule-data="editScheduleData"
            @delete-schedule-data="deleteScheduleData"
            @mouse-up="selectEndTime"
            @move-event="$emit('move-event')"
            @edit-event="$emit('edit-event', detail.start, detail.end)"
            @click-event="clickEvent(detail, index)"
        />

      </div>
    </div>

    <navigation :viewSize="scheduleViewSize"/>
    <unitDiv v-if="false"></unitDiv>
    <reservedDiv v-if="false"></reservedDiv>

    <appointment-modal
        :procedureData="dataAppointmentModal"
        :visible="visibleModalAppointment"
        @close="closeAppointmentModal"
    />

  </div>

</template>

<script>
import unitDiv from "./UnitDiv.vue"
import reservedDiv from "./ReservedDiv.vue"

import FindClient from "@/components/ganttCalendar/modal/FindClient.vue"
import AppointmentModal from "@/components/ganttCalendar/modal/Appointment.vue"
import Navigation from "@/components/ganttCalendar/Navigation.vue"

import {mapActions, mapGetters} from "vuex"

import moment from 'moment';
import 'moment-timezone';

export default {
  name: "ScheduleLite",
  components: {
    unitDiv: unitDiv,
    reservedDiv: reservedDiv,
    Navigation,
    FindClient,
    AppointmentModal,
  },
  props: {
    scheduleData: {
      required: true,
    },
    setting: {
      required: true,
    },
    departmentId: {
      required: true,
    },
    date: {},
  },
  data() {
    return {
      scheduleViewSize: {},
      trackNavigationView: null,

      dragAndMoveScheduler: {},
      dataAppointmentModal: {},
      dateCnt: 0,
      isSelecting: false,
      isSelectingRowIndex: null,
      isSelectingIndex: null,
      dragenterRowIndex: null,
      dragenterKeyIndex: null,
      clearSwitch: false,
      updateTime: null,
      currentTime: null,
      styleCurrentTime: {},
      width: null,
      load: false,
      loadCount: 0,
      scrollInterval: 0,
      timeLineStyle: {
        left: 0,
        opacity: "1",
        transition: '',
        zIndex: 12
      },
    };
  },
  created() {
    this.updateCurrentTime()

    this.updateTime = setInterval(() => {
      this.updateCurrentTime()
    }, 30 * 1000)



  },
  beforeDestroy () {
    if(!this.trackNavigationView) return
    this.trackNavigationView.unobserve(this.$refs.schedulerView)
  },
  mounted() {



    // this.initSize()

    this.timeLineStyle.transition = (navigator.userAgent.match(/iPad/i) != null) ? 'all .3s ease' : ''


    this.trackNavigationView = new ResizeObserver(this.initSize).observe(this.$refs.schedulerView)

    if(!this.width) this.width = this.$refs.schedulerView.scrollWidth





    // if (this.$refs.mainScroll)
    //   this.mainBoxWidth = this.$refs.mainScroll.scrollWidth + 'px'

  },
  destroyed() {
    clearTimeout(this.updateTime);
  },
  watch: {
    loading() {
      this.updateCurrentTime();

      if (this.isToday && this.loadCount === 0) this.$nextTick(() => {
        this.$refs.schedulerView.scrollTop = parseInt(this.styleCurrentTime.top ) - 50
      })

      this.loadCount++
    },
  },
  computed: {
    ...mapGetters("appointment", {
      visibleModalFindClient: "visibleModalFindClient",
      visibleModalAppointment: "visibleModalAppointment",
      loading: "loadAppointment",
    }),

    isToday() {
      const today = this.$root.convertTimeZone(null, 'Europe/Moscow')
      return (today >= new Date(this.dates.start) && today <= new Date(this.dates.end))
    },
    dates() {
      return {
        start: this.date.date_start,
        end: this.date.date_end,
      }
    },

    currentDay() {
      return {
        start: moment(this.date.date_start).toDate(),
        end: moment(this.date.date_end).toDate(),
      }
    },

    contentH() {
      return (this.padding + (this.setting.rowH + this.setting.borderW * 2) * this.scheduleData.length);
    },

    dateDivW() {
      return (
          this.setting.unitDivW * this.oneDayCnt + (this.oneDayCnt - this.setting.borderW)
      );
    },
    oneDayCnt() {
      return parseInt(1440 / this.setting.unit)
    },
    unitCnt() {
      return this.oneDayCnt * this.dateCnt
    },
    contentW() {
      return this.dateDivW * this.dateCnt + this.dateCnt * this.setting.borderW
    },
    timeDivW() {
      return ((60 / this.setting.unit) * (this.setting.unitDivW + this.setting.borderW) - 1)
    },
    padding() {
      return (
          this.setting.dateDivH + this.setting.timeDivH + this.setting.borderW * 4
      );
    },

  },
  methods: {
    ...mapActions({
      openFindClientModal: "appointment/OPEN_MODAL_FIND_CLIENT",
      getAppointment: "appointment/GET_APPOINTMENT",
      cleanAppointment: "appointment/CLEAN_APPOINTMENT",
      openModalAppointment: "appointment/OPEN_MODAL_APPOINTMENT",
      setCurrentUser: "appointment/SET_CURRENT_USER",
    }),
    initSize(wScroll, hScroll) {

      if(!this.$refs.schedulerView) return

      this.scheduleViewSize = {
        w: this.$refs.schedulerView.scrollWidth,
        h: this.$refs.schedulerView.scrollHeight,
        wOff: this.$refs.schedulerView.offsetWidth,
        hOff: this.$refs.schedulerView.offsetHeight,
        wScroll,
        hScroll
      }


    },
    onResizeView() {
      this.initSize();

    },
    toScroll(value) {
      this.$refs.scheduleContent.scrollLeft = this.$refs.scheduleContent.scrollLeft + value
    },
    toScrollStart(value, vertical) {

      this.scrollInterval = setInterval(() => {
        if (vertical) {
          this.$refs.schedulerView.scrollTop = this.$refs.schedulerView.scrollTop + value
        } else
          this.$refs.scheduleContent.scrollLeft = this.$refs.scheduleContent.scrollLeft + value
      }, 50)

    },
    toScrollStop() {
      clearTimeout(this.scrollInterval)
    },
    onScroll(element) {
      this.$refs.timelineRow.style.left = element.target.scrollLeft + 'px'
      if (!this.isToday) return

      this.$refs.currentTime.style.left = element.target.scrollLeft + 5 + 'px'
    },
    touchstart() {
      this.timeLineStyle.opacity = '0'
    },
    touchend() {
      this.timeLineStyle.opacity = '1'
    },
    touchMove(event) {

      event.preventDefault();
      let curX = event.targetTouches[0].pageX
      let curY = event.targetTouches[0].pageY
      event.targetTouches[0].target.style.webkitTransform = 'translate(' + curX + 'px, ' + curY + 'px)'
    },

    sumGap(unit = this.setting.unit) {
      let startDate = moment(this.dates.start).toDate()
      let endDate = moment(this.dates.end).toDate()

      let i = startDate
      let times = []

      while (i < endDate) {
        times.push(this.timeFormatter(i))
        i.setMinutes(i.getMinutes() + unit)
      }

      return times;
    },
    clickEvent(data, rowIndex) {

      console.log('clickEvent', data)

      this.dataAppointmentModal = {
        newStartDateObj: moment(data.start).toDate(),
        user: data.user,
        id: data.id,
        procedure: this.scheduleData[rowIndex],
        validate: false,
        payment_method: data.payment_method,
        payment_value: data.payment_value
      }

      this.setCurrentUser(data.user)
      this.openModalAppointment()
    },
    updateCurrentTime() {
      let currentTimeHeight = () => {
        let t = this.getMinutesDiff(moment(this.dates.start).toDate(), this.$root.convertTimeZone(null, 'Europe/Moscow'))

        return (t / this.setting.unit) * (this.setting.unitDivW) - 15
      }

      this.styleCurrentTime.top = currentTimeHeight() + 64 + "px"
      this.currentTime = this.$root.convertTimeZone(null, 'Europe/Moscow')

    },

    addZero(n) {
      return ("0" + n).slice(-2);
    },

    setDragenterRow(rowIndex) {
      this.dragenterRowIndex = rowIndex
    },

    setDragenterRowAndIndex(rowIndex, currentIndex) {

      setTimeout(() => {
        this.scrollInterval = 0
        this.dragAndMoveScheduler.isDown = false
        this.dragAndMoveScheduler.isMovie = false
      }, 50)


      this.dragenterRowIndex = rowIndex
      this.dragenterKeyIndex = currentIndex
    },

    disableDragendAnimation(e) {
      e.preventDefault()
    },

    getHeaderDate(n) {
      let startDate = this.addDays(new Date(this.dates.start), n)
      return this.dateFormatter(startDate, true)
    },

    getHeaderTime(n) {
      return n % 24
    },

    getDateDiff(date1, date2) {
      const diffTime = Math.abs(date2 - date1)
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    },

    dateFormatter(dateObj, withWeekDay) {
      let year = dateObj.getFullYear()
      let month = dateObj.getMonth() + 1
      if (month < 10) {
        month = "0" + month
      }
      let date = dateObj.getDate()
      if (withWeekDay) {
        let day = dateObj.getDay()
        let dayText = this.setting.weekdayText[day]
        return year + "/" + month + "/" + date + "(" + dayText + ")"
      }
      return year + "/" + month + "/" + date;
    },

    datetimeFormatter(dateObj) {
      let year = dateObj.getFullYear()
      let month = dateObj.getMonth() + 1
      if (month < 10) {
        month = "0" + month;
      }
      let date = dateObj.getDate()
      let hours = dateObj.getHours()
      if (hours < 10) {
        hours = "0" + hours
      }
      let minutes = dateObj.getMinutes()
      if (minutes < 10) {
        minutes = "0" + minutes
      }
      return year + "/" + month + "/" + date + " " + hours + ":" + minutes
    },
    timeFormatter(dateObj) {
      let hours = dateObj.getHours()
      if (hours < 10) {
        hours = "0" + hours
      }
      let minutes = dateObj.getMinutes()
      if (minutes < 10) {
        minutes = "0" + minutes
      }
      return hours + ":" + minutes
    },

    addDays(dateObj, n) {
      dateObj.setTime(dateObj.getTime() + n * 60 * 60 * 24 * 1000);
      return dateObj;
    },

    addMinutes(dateObj, n) {
      dateObj.setTime(dateObj.getTime() + n * 60 * 1000);
      return dateObj;
    },

    isBusiness: function () {
      // first check this div business day

      // and check this div time bussiness hour
      // let weekDay = thisDate.getDay();
      // // let businessHour = this.scheduleData[rowIndex].businessHours[weekDay];
      // // if (businessHour.start == "00:00" && businessHour.end == "24:00") {
      // //   // alltime
      // //   return true;
      // // }
      // //
      // // // has bussiness hour
      // // let businessStartTime = businessHour.start.replace(":", "");
      // // let businessEndTime = businessHour.end.replace(":", "");
      // let dateMod = n % oneDayCnt;
      // let divStartCnt = dateMod * this.setting.unit;
      // let divStartHour = parseInt(divStartCnt / 60);
      // if (divStartHour < 10) {
      //   divStartHour = "0" + divStartHour;
      // }
      // let divStartMin = parseInt(divStartCnt % 60);
      // if (divStartMin < 10) {
      //   divStartMin = "0" + divStartMin;
      // }
      // let divStartTime = divStartHour + "" + divStartMin;
      // if (divStartTime >= businessStartTime && divStartTime < businessEndTime) {
      //   return true;
      // }
      return true
    },

    isBusinessOnRange(rowIndex, startDateText, endDateText) {
      let startDiff = this.getMinutesDiff(
          new Date(this.dates.start),
          new Date(startDateText)
      );
      let startCnt = parseInt(startDiff / this.setting.unit);
      let endDiff = this.getMinutesDiff(
          new Date(this.dates.start),
          new Date(endDateText)
      );
      let endCnt = parseInt(endDiff / this.setting.unit);
      let result = true
      for (var i = startCnt; i < endCnt; i++) {
        if (!this.isBusiness(rowIndex, i)) {
          result = false
        }
      }
      return result
    },

    hasOtherEvent(index, oldRowIndex, newRowIndex, startDateText, endDateText) {
      for (
          var n = 0;
          n < this.scheduleData[newRowIndex].taken_appointment.length;
          n++
      ) {
        if (n !== index || oldRowIndex !== newRowIndex) {
          let diffData = this.scheduleData[newRowIndex].taken_appointment[n]
          if (
              new Date(diffData.start) - new Date(startDateText) >= 0 &&
              new Date(diffData.end) - new Date(endDateText) <= 0
          ) {
            return true
          }
          if (
              new Date(diffData.start) - new Date(startDateText) >= 0 &&
              new Date(diffData.start) - new Date(endDateText) < 0
          ) {
            return true
          }
          if (
              new Date(diffData.start) - new Date(startDateText) <= 0 &&
              new Date(diffData.end) - new Date(startDateText) > 0
          ) {
            return true
          }
        }
      }
      return false
    },

    isHourTime(rowIndex, keyIndex) {
      let addMinutes = (keyIndex - 1) * this.scheduleData[rowIndex].duration
      let newStartDateObj = this.addMinutes(
          moment(this.dates.start).toDate(),
          addMinutes
      )


      return newStartDateObj.getMinutes() === 0 || newStartDateObj.getMinutes() === 30 ? true : false

    },
    clickStartTime(rowIndex, keyIndex) {

      if(this.dragAndMoveScheduler.isMovie) return

      let addMinutes = (keyIndex - 1) * this.scheduleData[rowIndex].duration
      let newStartDateObj = this.addMinutes(
          moment(this.dates.start).toDate(),
          addMinutes
      )
      let newEndDateObj = this.addMinutes(
          moment(this.dates.start).toDate(),
          addMinutes + this.scheduleData[rowIndex].duration
      );


      if ((newEndDateObj) > new Date(this.dates.end)) {
        return this.$notify.warning({
          title: "Что-то не так",
          message: "Процедура занимает больше времени, чем работа центра",
        })
      }

      // if (new Date(newStartDateObj) < this.$root.convertTimeZone(null, 'Europe/Moscow')) {
      //   return this.$notify.warning({
      //     title: "Что-то не так",
      //     message: "Нельзя добавить запись в прошлом",
      //   })
      // }

      this.dataAppointmentModal = {
        newStartDateObj,
        rowIndex,
        keyIndex,
        user: null,
        validate: false,
        procedure: this.scheduleData[rowIndex],
      }

      this.openFindClientModal()
    },
    // Создание новой записи by перетаскивание
    selectStartTime(rowIndex, keyIndex) {
      this.isSelecting = true
      this.isSelectingRowIndex = rowIndex
      let addMinutes = (keyIndex - 1) * this.setting.unit
      let addMinutes2 = keyIndex * this.setting.unit
      let newStartDateObj = this.addMinutes(
          moment(this.dates.start).toDate(),
          addMinutes
      )

      this.dataAppointmentModal = {
        newStartDateObj,
        rowIndex,
        keyIndex,
      }
      this.openAppointmentModal()

      return

      // eslint-disable-next-line no-unreachable
      let newEndDateObj = this.addMinutes(
          new Date(this.dates.start),
          addMinutes2
      )
      this.scheduleData[rowIndex].taken_appointment.push({
        text: "New",
        start: this.datetimeFormatter(newStartDateObj),
        end: this.datetimeFormatter(newEndDateObj),
      })
      this.isSelectingIndex =
          this.scheduleData[this.isSelectingRowIndex].taken_appointment.length - 1
    },

    adjustTimeRange(keyIndex) {
      let targetIndex =
          this.scheduleData[this.isSelectingRowIndex].taken_appointment.length - 1
      let targetData = this.scheduleData[this.isSelectingRowIndex]
          .taken_appointment[targetIndex]
      if (targetData) {
        let addMinutes = keyIndex * this.setting.unit
        let newEndDateObj = this.addMinutes(
            new Date(this.dates.start),
            addMinutes
        )
        let newEndDateText = this.datetimeFormatter(newEndDateObj)
        let isPermission = true

        // Check other event
        if (
            this.hasOtherEvent(
                targetIndex,
                this.isSelectingRowIndex,
                this.isSelectingRowIndex,
                targetData.start,
                newEndDateText
            )
        ) {
          isPermission = false
        }

        // Check Businessday
        if (isPermission) {
          isPermission = this.isBusinessOnRange(
              this.isSelectingRowIndex,
              targetData.start,
              newEndDateText
          );
        }
        if (isPermission) {
          targetData.end = newEndDateText
        }
      }
    },

    selectEndTime(startDate, endDate) {
      if (this.isSelecting) {

        if (!startDate) {
          let targetData = this.scheduleData[this.isSelectingRowIndex]
              .taken_appointment[
          this.scheduleData[this.isSelectingRowIndex].taken_appointment
              .length - 1
              ]
          startDate = targetData.start
          endDate = targetData.end
        }
        this.$emit("add-event", this.isSelectingRowIndex, startDate, endDate)
      }
      this.isSelecting = false
      this.isSelectingRowIndex = null
      this.isSelectingIndex = null
      this.clearSwitch = !this.clearSwitch
    },

    moveScheduleData(rowIndex, keyNo, unitCnt) {

      if (rowIndex !== this.dragenterRowIndex) {
        this.$notify.warning({
          title: "Ошибка перемещения 😕😕",
          message: "Возможность изменения типа процедуры ограничена, создайте другую",
        })

        return 0
      }

      let targetData = this.scheduleData[rowIndex].taken_appointment[keyNo]
      if (targetData) {
        let status = 0
        let isBusinessFlag = true
        let isBusinessChecked = false


        let changeDatetimeText = (datetimeText) => {

          let addMinutes = unitCnt * this.setting.unit
          let dateObj = moment(datetimeText).toDate()

          let newDateObj = this.addMinutes(dateObj, addMinutes)
          return this.datetimeFormatter(newDateObj)
        }

        let newStartDatetime = changeDatetimeText(targetData.start)
        let newEndDatetime = changeDatetimeText(targetData.end)


        if (unitCnt !== 0) {
          if (
              this.hasOtherEvent(
                  keyNo,
                  rowIndex,
                  this.dragenterRowIndex,
                  newStartDatetime,
                  newEndDatetime
              )
          ) {
            status = 2

            this.$notify.warning({
              title: "Что-то не так.",
              message: "Поле занято, загружаю актуальное рассписание",
            })

            this.cleanAppointment()
            this.getAppointment()


          } else {
            isBusinessFlag = this.isBusinessOnRange(
                this.dragenterRowIndex,
                newStartDatetime,
                newEndDatetime
            )
            if (isBusinessFlag) {
              targetData.start = newStartDatetime
              targetData.end = newEndDatetime
              status = 1
            }
            isBusinessChecked = true
          }
        }

        if (rowIndex !== this.dragenterRowIndex && this.scheduleData[this.dragenterRowIndex]) {
          if (isBusinessChecked && !isBusinessFlag) {
            this.$emit("move-event", status)
            return
          }
          if (!isBusinessChecked && isBusinessFlag) {
            // Поле занято

            if (this.hasOtherEvent(
                keyNo,
                rowIndex,
                this.dragenterRowIndex,
                newStartDatetime,
                newEndDatetime)) {
              status = 2
              this.$emit("move-event", status)
              return
            }
            isBusinessFlag = this.isBusinessOnRange(
                this.dragenterRowIndex,
                targetData.start,
                targetData.end
            )
            isBusinessChecked = true
          }
          if (isBusinessChecked && isBusinessFlag) {
            // Успешное передвижение

            this.scheduleData[this.dragenterRowIndex].taken_appointment.push(
                targetData
            )
            this.scheduleData[rowIndex].taken_appointment.splice(keyNo, 1)
            status = 1
          }
        }

        if (status === 1) {
          if (
              new Date(targetData.start) < new Date(this.date.date_start) ||
              new Date(targetData.start) > new Date(this.date.date_end)
          ) {
            this.$notify.warning({
              title: "Что-то не так",
              message: "Вы вышли за рамки",
            })
            this.getAppointment()

            return 0
          }

          targetData.moving = true

          this.$api.appointments
              .update(this.departmentId, targetData.id, {
                start: this.$root.dateTime(targetData.start, true),
              })
              .then(() => {
                this.$emit(
                    "move-event",
                    status,
                    targetData.start,
                    targetData.end
                )

                this.$notify.success({
                  title: "Удачно...",
                  message: "Запись изменена",
                })
              })
              .catch((response) => {
                this.$notify.error({
                  title: "Ошибка перемещения 😕",
                  message: response.response.data.message,
                })
              })
              .finally(() => {
                this.$set(targetData, "moving", false)
                this.getAppointment()
              })
        }
      }
    },

    editScheduleData(rowIndex, keyNo, unitCnt) {
      let targetData = this.scheduleData[rowIndex].taken_appointment[keyNo]
      if (targetData) {
        let changeDatetimeText = (datetimeText) => {
          let addMinutes = unitCnt * this.setting.unit
          let dateObj = new Date(datetimeText)
          let newDateObj = this.addMinutes(dateObj, addMinutes)
          return this.datetimeFormatter(newDateObj)
        }
        let newEndText = changeDatetimeText(targetData.end)
        if (
            this.hasOtherEvent(
                keyNo,
                rowIndex,
                rowIndex,
                targetData.start,
                newEndText
            )
        ) {
          return
        }
        targetData.end = newEndText
      }
    },

    deleteScheduleData(rowIndex, keyNo) {
      this.scheduleData[rowIndex].taken_appointment.splice(keyNo, 1)
      this.$emit("delete-event", rowIndex, keyNo)
    },

    getMinutesDiff(date1, date2) {
      if (date2 - date1 < 0) return
      const diffTime = Math.abs(date2 - date1)

      return Math.ceil(diffTime / (1000 * 60))
    },
    closeAppointmentModal() {
      this.dataAppointmentModal = {}
    },

    scrollScheduler(event) {
      this.initSize(event.target.scrollLeft, event.target.scrollTop)
    },
    moveScheduler(event) {

      if(this.dragAndMoveScheduler.isDown){
        // event.preventDefault();

        if(this.dragAndMoveScheduler.startY !== event.pageY) {
          this.dragAndMoveScheduler.isMovie  = true
        }

        // vertically
        const y = event.pageY - this.$refs.schedulerView.offsetTop;
        const walkY = y - this.dragAndMoveScheduler.startY;
        this.$refs.schedulerView.scrollTop = this.dragAndMoveScheduler.scrollTop - walkY;

        // horizontally
        const x = event.pageX - this.$refs.schedulerView.offsetLeft;
        const walkX = x - this.dragAndMoveScheduler.startX;
        this.$refs.schedulerView.scrollLeft = this.dragAndMoveScheduler.scrollLeft - walkX;
      }

    },
    stopTrack() {

    },
    mousedown(event) {

      this.dragAndMoveScheduler = {
        isDown: true,
        isMovie: false,
        startY : event.pageY - this.$refs.schedulerView.offsetTop,
        startX : event.pageX - this.$refs.schedulerView.offsetLeft,
        scrollLeft: this.$refs.schedulerView.scrollLeft,
        scrollTop: this.$refs.schedulerView.scrollTop
      }

    },
    mouseup() {

      this.dragAndMoveScheduler.isDown = false
      setTimeout(() => {
        this.dragAndMoveScheduler.isMovie = false
      }, 50)

    },
    mouseleave() {
      this.dragAndMoveScheduler.isDown = false

    }

  },
}
</script>

<style scoped lang="scss">


.scheduler {
  //margin-top: 20px;
  width: 100%;
  height: calc(100vh - 300px);
  overflow: scroll;

  position: relative;
  z-index: 9;

  display: flex;
  justify-content: start;
  align-items: flex-start;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none;   /* Chrome/Safari/Opera */
  -khtml-user-select: none;    /* Konqueror */
  -moz-user-select: none;      /* Firefox */
  -ms-user-select: none;       /* Internet Explorer/Edge */
  user-select: none;
}

.scheduler__column {
  margin-bottom: 10px;
  width: 100%;

  border-right: 2px solid #eaeaea;

  position: relative;
  z-index: 11;

  &_hidden {
    width: 0;
    border: 0;
  }

  &:nth-child(1) {
    background: #f6f8f9;
    //z-index: 10!important;

  }
}

.column__cell {
  //padding: 0 8px;
  white-space: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;
}

.scheduler .header {
  background: #f6f8f9;
  margin-bottom: 35px;

  position: sticky;
  top: 0;
  z-index: 11;

  padding: 6px 20px;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;

  color: #111;

  border-top: 2px solid #EAEAEA;
  border-bottom: 2px solid #EAEAEA;



}

.scheduler .scheduler__column:nth-child(1) {
  position: sticky;
  width: 100px;
  left: 0;
  z-index: 10;

}


.schedule-header {
  width: 100%;

  border-color: #c0c0c0;
  padding: 0;

  position: relative;

  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 13px;

  letter-spacing: 0.005em;

  color: #111;

  &__content {
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    margin-left: 60px;
    display: flex;
  }
}

.schedule-nav {
  position: relative;
  z-index: 9;

  .arrow-left {
    background: rgb(255, 255, 255);
    background: radial-gradient(circle, #ffff 0%, #ff000000 100%);

    position: absolute;
    top: 8px;
    left: 0;
    z-index: 12;

    width: 60px;
    height: 34px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .arrow-right {
    background: rgb(255, 255, 255);
    background: radial-gradient(circle, #ffff 0%, #ff000000 100%);

    position: absolute;
    top: 18px;
    right: 0;
    z-index: 12;

    width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.schedule-header .title {
  background: #00fcff;
}

.procedure-name {
  //margin-right: 10px;
  padding: 20px 0 20px 0;
  //border-right: solid 1px #fff;

  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;

  display: flex;
  align-items: center;
  letter-spacing: -0.005em;
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: #111;
}

.sc-time {
  display: block;
  width: 102px;

  border-top: 0;

  font-style: normal;
  font-weight: 500;

  line-height: 22px;

  text-align: center;
  letter-spacing: -0.005em;

  color: #676767;

  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0 0;

  position: relative;
  top: -10px;

  &__line {
    position: absolute;
    top: 82px;
    z-index: 9;
    left: 0;

    height: 0;
    width: calc(100vw);
    background-size: 15px 5px;
    border: 2px solid #EAEAEA;

  }

  //&:after {
  //  content: "";
  //
  //  width: 100%;
  //  margin: 0;
  //  height: 2px;
  //  border: none;
  //  background: #EAEAEA;
  //  background-size: 16px 2px;
  //
  //  position: absolute;
  //  top: -2px;
  //  left: -13px;
  //}
}

.sc-main-box {
  transition: all .1s;
  width: 100%;
  height: calc(100vh - 400px);

  overflow-x: hidden;
  overflow-y: auto;

}

.sc-main {
  display: flex;
  position: relative;
}

.timeline {
  //margin-right: 24px;
  position: relative;

  z-index: 5;

  &.time {
    position: relative;
  }

  &:after {
    content: " ";
    height: 100%;

    width: 2px;

    background: #EAEAEA;
    background-size: 2px 16px;

    border: none;

    position: absolute;
    z-index: 5;
    top: -44px;
    right: 0;
  }
}

.current-time {
  width: calc(100% - 50px);
  position: absolute;
  left: 26px;
  top: 0;
  z-index: 10;
  transition: top 0.5s ease;


  &:hover {
    opacity: 0.3;
  }

  :after {
    content: " ";
    height: 0;
    width: 100vw;

    background-size: 15px 5px;
    border: 2px solid #43D3B3;

    top: 17px;
    left: 78px;
    position: absolute;
  }

  :before {
    content: " ";
    height: 8px;
    width: 8px;

    background: #43D3B3;
    border-radius: 50%;

    top: 15px;
    left: 71px;
    position: absolute;
  }

  &__time {
    box-sizing: border-box;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    color: #43D3B3;
    background: rgba(246, 248, 249, 0.6);
    border-radius: 4px;
    margin: 5px 0 0 0;
    padding: 2px 0;

    text-align: center;
  }
}

.ui-draggable-dragging,
.ui-resizeable {
  z-index: 20;
}

.timeline,
.sc-main .tb {
  //border-right: solid 1px #fff;
}



.timeline-row {
  position: sticky;
  z-index: 6;

  &:after {
    right: 0;
  }
}

.scroll-bar {
  position: fixed;
  bottom: 56px;
  width: 100%;
  height: 40px;
  z-index: 99;
}

.hour-line {
  width: 100%;
  border-top: 0;

  position: relative;
  transition: background 0.2s ease;


  //&:hover {
  //  background: #f8f8f8;
  //}

  //&:after {
  //  content: "";
  //
  //  width: 100%;
  //  margin: 0;
  //  height: 2px;
  //  border: none;
  //  background: #EAEAEA;
  //
  //  background-size: 16px 2px;
  //
  //  position: absolute;
  //  top: 0;
  //}
}

.time-icon {
  text-align: center;
  padding: 10px 0;


  i {
    font-size: 17px;
    color: #676767;
  }
}

</style>
